import { useTooltipData } from '../../../../core/components/overlay-tooltip/_to-be-removed/utils.js';
import { Series } from '../../../../core/components/overlay-tooltip/components/series/Series.js';
import { SeriesItem } from '../../../../core/components/overlay-tooltip/components/series/SeriesItem.js';
import { OverlayTooltip } from '../../../../core/components/overlay-tooltip/OverlayTooltip.js';
import type { Data } from '../../../../core/components/overlay-tooltip/types.js';
import { isTooltipDataEmpty } from '../../../../core/components/overlay-tooltip/utils.js';
import type { SeriesActionsTemplate } from '../../../../core/types/series-actions-template.js';

type SeriesData = Data['series'][number];

interface MeterBarTooltipContentProps {
  activeItem?: number;
  variant?: 'shared' | 'single';
  actionsForItem?: (
    item: SeriesData,
  ) => (() => SeriesActionsTemplate) | undefined;
}

export const MeterBarChartTooltip = ({
  activeItem,
  variant,
  actionsForItem,
}: MeterBarTooltipContentProps) => {
  const data = useTooltipData().data;

  if (isTooltipDataEmpty(data)) {
    return null;
  }

  return (
    <OverlayTooltip>
      <Series
        data={data.series}
        variant={variant}
        activeItem={activeItem}
        seriesItemTemplate={(item) => (
          <SeriesItem {...item} actions={actionsForItem?.(item)} />
        )}
      />
    </OverlayTooltip>
  );
};
